<!-- To Do List -->
<div class="trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md">
    <div class="trezo-card-header mb-[20px] md:mb-[25px] sm:flex items-center justify-between">
        <div class="trezo-card-title">
            <h5 class="!mb-0">
                To Do List
            </h5>
        </div>
        <div class="trezo-card-subtitle mt-[15px] sm:mt-0">
            <form class="relative sm:w-[265px]">
                <label class="leading-none absolute ltr:left-[13px] rtl:right-[13px] text-black dark:text-white mt-px top-1/2 -translate-y-1/2">
                    <i class="material-symbols-outlined !text-[20px] text-sky-600">
                        search
                    </i>
                </label>
                <input type="text" placeholder="Search here....." class="bg-gray-50 border border-gray-50 h-[36px] text-xs rounded-md w-full block text-black pt-[11px] pb-[12px] ltr:pl-[38px] rtl:pr-[38px] ltr:pr-[13px] ltr:md:pr-[16px] rtl:pl-[13px] rtl:md:pl-[16px] placeholder:text-gray-500 outline-0 dark:bg-[#15203c] dark:text-white dark:border-[#15203c] dark:placeholder:text-gray-400">
            </form>
        </div>
    </div>
    <div class="trezo-card-content -mx-[20px] md:-mx-[25px]">
        <div class="table-responsive overflow-x-auto">
            <table class="w-full">
                <thead class="text-black dark:text-white">
                    <tr>
                        <th class="font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap">
                            <div class="form-check relative top-[2px]">
                                <input type="checkbox" class="cursor-pointer">
                            </div>
                        </th>
                        <th class="font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap">
                            ID
                        </th>
                        <th class="font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap">
                            Task Title
                        </th>
                        <th class="font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap">
                            Assigned To
                        </th>
                        <th class="font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap">
                            Due Date
                        </th>
                        <th class="font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap">
                            Priority
                        </th>
                        <th class="font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap">
                            Status
                        </th>
                        <th class="font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap">
                            Action
                        </th>
                    </tr>
                </thead>
                <tbody class="text-black dark:text-white">
                    <tr>
                        <td class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]">
                            <div class="form-check relative top-[2px]">
                                <input type="checkbox" class="cursor-pointer">
                            </div>
                        </td>
                        <td class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]">
                            <span class="text-gray-500 dark:text-gray-400">
                                #854
                            </span>
                        </td>
                        <td class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]">
                            <span class="block font-medium text-gray-500 dark:text-gray-400">
                                Network Infrastructure
                            </span>
                        </td>
                        <td class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]">
                            Oliver Clark
                        </td>
                        <td class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]">
                            <span class="text-gray-500 dark:text-gray-400">
                                30 Apr 2025
                            </span>
                        </td>
                        <td class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]">
                            <span class="text-gray-500 dark:text-gray-400">
                                High
                            </span>
                        </td>
                        <td class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]">
                            <span class="px-[8px] py-[3px] inline-block bg-primary-50 dark:bg-[#15203c] text-primary-500 rounded-sm font-medium text-xs">
                                Finished
                            </span>
                        </td>
                        <td class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]">
                            <div class="flex items-center gap-[9px]">
                                <button type="button" class="text-primary-500 leading-none">
                                    <i class="material-symbols-outlined !text-md">
                                        visibility
                                    </i>
                                </button>
                                <button type="button" class="text-gray-500 dark:text-gray-400 leading-none">
                                    <i class="material-symbols-outlined !text-md">
                                        edit
                                    </i>
                                </button>
                                <button type="button" class="text-danger-500 leading-none">
                                    <i class="material-symbols-outlined !text-md">
                                        delete
                                    </i>
                                </button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]">
                            <div class="form-check relative top-[2px]">
                                <input type="checkbox" class="cursor-pointer">
                            </div>
                        </td>
                        <td class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]">
                            <span class="text-gray-500 dark:text-gray-400">
                                #853
                            </span>
                        </td>
                        <td class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]">
                            <span class="block font-medium text-gray-500 dark:text-gray-400">
                                Cloud Migration
                            </span>
                        </td>
                        <td class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]">
                            Ethan Baker
                        </td>
                        <td class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]">
                            <span class="text-gray-500 dark:text-gray-400">
                                25 Apr 2025
                            </span>
                        </td>
                        <td class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]">
                            <span class="text-gray-500 dark:text-gray-400">
                                Low
                            </span>
                        </td>
                        <td class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]">
                            <span class="px-[8px] py-[3px] inline-block bg-warning-50 dark:bg-[#15203c] text-warning-500 rounded-sm font-medium text-xs">
                                Pending
                            </span>
                        </td>
                        <td class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]">
                            <div class="flex items-center gap-[9px]">
                                <button type="button" class="text-primary-500 leading-none">
                                    <i class="material-symbols-outlined !text-md">
                                        visibility
                                    </i>
                                </button>
                                <button type="button" class="text-gray-500 dark:text-gray-400 leading-none">
                                    <i class="material-symbols-outlined !text-md">
                                        edit
                                    </i>
                                </button>
                                <button type="button" class="text-danger-500 leading-none">
                                    <i class="material-symbols-outlined !text-md">
                                        delete
                                    </i>
                                </button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]">
                            <div class="form-check relative top-[2px]">
                                <input type="checkbox" class="cursor-pointer">
                            </div>
                        </td>
                        <td class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]">
                            <span class="text-gray-500 dark:text-gray-400">
                                #852
                            </span>
                        </td>
                        <td class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]">
                            <span class="block font-medium text-gray-500 dark:text-gray-400">
                                Website Revamp
                            </span>
                        </td>
                        <td class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]">
                            Sophia Carter
                        </td>
                        <td class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]">
                            <span class="text-gray-500 dark:text-gray-400">
                                20 Apr 2025
                            </span>
                        </td>
                        <td class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]">
                            <span class="text-gray-500 dark:text-gray-400">
                                Medium
                            </span>
                        </td>
                        <td class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]">
                            <span class="px-[8px] py-[3px] inline-block bg-success-50 dark:bg-[#15203c] text-success-500 rounded-sm font-medium text-xs">
                                In Progress
                            </span>
                        </td>
                        <td class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]">
                            <div class="flex items-center gap-[9px]">
                                <button type="button" class="text-primary-500 leading-none">
                                    <i class="material-symbols-outlined !text-md">
                                        visibility
                                    </i>
                                </button>
                                <button type="button" class="text-gray-500 dark:text-gray-400 leading-none">
                                    <i class="material-symbols-outlined !text-md">
                                        edit
                                    </i>
                                </button>
                                <button type="button" class="text-danger-500 leading-none">
                                    <i class="material-symbols-outlined !text-md">
                                        delete
                                    </i>
                                </button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]">
                            <div class="form-check relative top-[2px]">
                                <input type="checkbox" class="cursor-pointer">
                            </div>
                        </td>
                        <td class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]">
                            <span class="text-gray-500 dark:text-gray-400">
                                #851
                            </span>
                        </td>
                        <td class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]">
                            <span class="block font-medium text-gray-500 dark:text-gray-400">
                                Mobile Application
                            </span>
                        </td>
                        <td class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]">
                            Ava Cooper
                        </td>
                        <td class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]">
                            <span class="text-gray-500 dark:text-gray-400">
                                15 Apr 2025
                            </span>
                        </td>
                        <td class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]">
                            <span class="text-gray-500 dark:text-gray-400">
                                High
                            </span>
                        </td>
                        <td class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]">
                            <span class="px-[8px] py-[3px] inline-block bg-primary-50 dark:bg-[#15203c] text-primary-500 rounded-sm font-medium text-xs">
                                Finished
                            </span>
                        </td>
                        <td class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]">
                            <div class="flex items-center gap-[9px]">
                                <button type="button" class="text-primary-500 leading-none">
                                    <i class="material-symbols-outlined !text-md">
                                        visibility
                                    </i>
                                </button>
                                <button type="button" class="text-gray-500 dark:text-gray-400 leading-none">
                                    <i class="material-symbols-outlined !text-md">
                                        edit
                                    </i>
                                </button>
                                <button type="button" class="text-danger-500 leading-none">
                                    <i class="material-symbols-outlined !text-md">
                                        delete
                                    </i>
                                </button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]">
                            <div class="form-check relative top-[2px]">
                                <input type="checkbox" class="cursor-pointer">
                            </div>
                        </td>
                        <td class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]">
                            <span class="text-gray-500 dark:text-gray-400">
                                #850
                            </span>
                        </td>
                        <td class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]">
                            <span class="block font-medium text-gray-500 dark:text-gray-400">
                                System Deployment
                            </span>
                        </td>
                        <td class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]">
                            Isabella Evans
                        </td>
                        <td class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]">
                            <span class="text-gray-500 dark:text-gray-400">
                                10 Apr 2025
                            </span>
                        </td>
                        <td class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]">
                            <span class="text-gray-500 dark:text-gray-400">
                                Low
                            </span>
                        </td>
                        <td class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]">
                            <span class="px-[8px] py-[3px] inline-block bg-danger-50 dark:bg-[#15203c] text-danger-500 rounded-sm font-medium text-xs">
                                Cancelled
                            </span>
                        </td>
                        <td class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]">
                            <div class="flex items-center gap-[9px]">
                                <button type="button" class="text-primary-500 leading-none">
                                    <i class="material-symbols-outlined !text-md">
                                        visibility
                                    </i>
                                </button>
                                <button type="button" class="text-gray-500 dark:text-gray-400 leading-none">
                                    <i class="material-symbols-outlined !text-md">
                                        edit
                                    </i>
                                </button>
                                <button type="button" class="text-danger-500 leading-none">
                                    <i class="material-symbols-outlined !text-md">
                                        delete
                                    </i>
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="px-[25px] pt-[12px] md:pt-[15px] ltr:text-right rtl:text-left">
            <button type="button" class="inline-block transition-all rounded-md font-medium px-[13px] py-[6px] text-primary-500 border border-primary-500 hover:bg-primary-500 hover:text-white" (click)="toggleClass()">
                <span class="inline-block relative ltr:pl-[22px] rtl:pr-[22px]">
                    <i class="material-symbols-outlined !text-[22px] absolute ltr:-left-[4px] rtl:-right-[4px] top-1/2 -translate-y-1/2">
                        add
                    </i>
                    Add New Task
                </span>
            </button>
        </div>
    </div>
</div>

<!-- Add New Popup -->
<div
    class="add-new-popup z-[999] fixed transition-all inset-0 overflow-x-hidden overflow-y-auto lg:py-[20px]"
    [class.active]="classApplied"
>
    <div class="popup-dialog flex transition-all max-w-[550px] min-h-full items-center mx-auto">
        <div class="trezo-card w-full bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md">
            <div class="trezo-card-header bg-gray-50 dark:bg-[#15203c] mb-[20px] md:mb-[25px] flex items-center justify-between -mx-[20px] md:-mx-[25px] -mt-[20px] md:-mt-[25px] p-[20px] md:p-[25px] rounded-t-md">
                <div class="trezo-card-title">
                    <h5 class="!mb-0">
                        Add New Task
                    </h5>
                </div>
                <div class="trezo-card-subtitle">
                    <button
                        (click)="toggleClass()"
                        class="text-[23px] transition-all leading-none text-black dark:text-white hover:text-primary-500"
                    >
                        <i class="ri-close-fill"></i>
                    </button>
                </div>
            </div>
            <div class="trezo-card-content">
                <form>
                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-[20px] md:gap-[25px]">
                        <div class="sm:col-span-2">
                            <label class="mb-[10px] text-black dark:text-white font-medium block">
                                Task Title
                            </label>
                            <input type="text" class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500" placeholder="Task title">
                        </div>
                        <div>
                            <label class="mb-[10px] text-black dark:text-white font-medium block">
                                Assigned To
                            </label>
                            <select class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[14px] block w-full outline-0 cursor-pointer transition-all focus:border-primary-500">
                                <option>
                                    Select
                                </option>
                                <option>
                                    Shawn Kennedy
                                </option>
                                <option>
                                    Roberto Cruz
                                </option>
                                <option>
                                    Juli Johnson
                                </option>
                                <option>
                                    Catalina Engles
                                </option>
                                <option>
                                    Louis Nagle
                                </option>
                                <option>
                                    Michael Marquez
                                </option>
                            </select>
                        </div>
                        <div>
                            <label class="mb-[10px] text-black dark:text-white font-medium block">
                                Due Date
                            </label>
                            <input type="date" class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500">
                        </div>
                        <div>
                            <label class="mb-[10px] text-black dark:text-white font-medium block">
                                Priority
                            </label>
                            <select class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[14px] block w-full outline-0 cursor-pointer transition-all focus:border-primary-500">
                                <option>
                                    Select
                                </option>
                                <option>
                                    High
                                </option>
                                <option>
                                    Medium
                                </option>
                                <option>
                                    Low
                                </option>
                            </select>
                        </div>
                        <div>
                            <label class="mb-[10px] text-black dark:text-white font-medium block">
                                Status
                            </label>
                            <select class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[14px] block w-full outline-0 cursor-pointer transition-all focus:border-primary-500">
                                <option>
                                    Select
                                </option>
                                <option>
                                    In Progress
                                </option>
                                <option>
                                    Pending
                                </option>
                                <option>
                                    Completed
                                </option>
                                <option>
                                    Not Started
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="mt-[20px] md:mt-[25px] ltr:text-right rtl:text-left">
                        <button type="button" class="rounded-md inline-block transition-all font-medium ltr:mr-[15px] rtl:ml-[15px] px-[26.5px] py-[12px] bg-danger-500 text-white hover:bg-danger-400" (click)="toggleClass()">
                            Cancel
                        </button>
                        <button type="button" class="inline-block bg-primary-500 text-white py-[12px] px-[26.5px] transition-all rounded-md hover:bg-primary-400">
                            <span class="inline-block relative ltr:pl-[25px] rtl:pr-[25px]">
                                <i class="material-symbols-outlined !text-[20px] absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2">
                                    add
                                </i>
                                Create
                            </span>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>